export const alarmTypeOptions = [
  { value: "normal", label: "Normal" },
  { value: "bits", label: "Bits" },
  { value: "integer", label: "Numerical" },
];

export const logsNumber = [
  { value: "port", label: "PORT" },
  { value: "stbd", label: "STBD" },
];

export const defaultColumns = [
  { key: "id", label: "Number", visible: true, background: null },
  { key: "message", label: "Message", visible: true, background: null },
  { key: "frequency", label: "Frequency", visible: true, background: null },
  {
    key: "trigger",
    label: "Trigger",
    visible: true,
    background: null,
    onlyAvailable: "#ff5286",
  },
  {
    key: "acknowledge",
    label: "Acknowledge",
    visible: true,
    background: null,
    onlyAvailable: "#fbad37",
  },
  {
    key: "recovery",
    label: "Recovery",
    visible: true,
    background: null,
    onlyAvailable: "#4CAF50",
  },
  { key: "duration", label: "Duration", visible: true, background: null },
];

export const liveAlarmColumns = [
  { key: "plc", label: "PLC", visible: true, background: null },
  {
    key: "group",
    label: "Group",
    visible: true,
    background: null,
  },
  {
    key: "acknowledgeStatus",
    label: "Acknowledge Status",
    ackStatus: true,
    visible: true,
    background: null,
  },
  { key: "message", label: "Message", visible: true, background: null },
  { key: "active", label: "Active", visible: false, background: null },
  { key: "live", label: "Live", visible: false, background: null },

  {
    key: "trigger",
    label: "Trigger (Ts)",
    visible: false,
    background: null,
  },
  {
    key: "acknowledgeTs",
    label: "Acknowledge (Ts)",
    visible: false,
    background: null,
  },
];

/* Saved widgets keep their own columns: add any newer default column after "message" */
export function withLiveAlarmColumns(columns) {
  if (!Array.isArray(columns)) return liveAlarmColumns;

  const missing = liveAlarmColumns.filter(function (defaultColumn) {
    return !columns.some(function (column) {
      return column.key === defaultColumn.key;
    });
  });
  if (missing.length === 0) return columns;

  const messageIndex = columns.findIndex(function (column) {
    return column.key === "message";
  });
  const insertAt = messageIndex === -1 ? columns.length : messageIndex + 1;
  return [...columns.slice(0, insertAt), ...missing, ...columns.slice(insertAt)];
}
